import { useTranslation } from "gatsby-plugin-react-i18next";
import { RoomType } from "../../constants/constants";

export type Room = {
  code: RoomType;
  name: string;
  image: string;
  price: string;
  description: string;
  images: string[];
  amenities: string[];
  roomDetails: {
    room: {
      items: string[];
    };
    bathroom: {
      items: string[];
    };
  };
};

export const useRoomDetails = (): Room[] => {
  const { t: tRooms } = useTranslation("rooms");
  const { t: tHome } = useTranslation("home");

  const defaultAmenities = [
    tHome("facilities.items.clim.title"),
    tHome("facilities.items.safe.title"),
    tHome("facilities.items.wifi.title"),
    tHome("facilities.items.late.title"),
    tHome("facilities.items.cafe.title"),
    tHome("facilities.items.bouilloire.title"),
    tHome("facilities.items.frigo.title"),
  ];

  const defaultBathroomItems = [
    tRooms("section.bathroom.items.shower"),
    tRooms("section.bathroom.items.clarins"),
    tRooms("section.bathroom.items.hairDryer"),
  ];

  return [
    {
      code: "chambre-simple",
      name: tRooms("items.chambre-simple.title"),
      image: "/images/rooms/simple/1.jpg",
      price: tRooms("similarRooms.price", { price: "130" }),
      description: tRooms("items.chambre-simple.description"),
      images: [
        "/images/rooms/simple/1.jpg",
        "/images/rooms/simple/2.jpg",
        "/images/rooms/simple/3.jpg",
      ],
      amenities: defaultAmenities,
      roomDetails: {
        room: {
          items: [
            tRooms("section.roomDetails.items.roomSize", { size: "12" }),
            tRooms("section.roomDetails.items.kingSizeBed"),
            tRooms("section.roomDetails.items.streetside"),
            tRooms("section.roomDetails.items.maxGuests", { count: 1 }),
          ],
        },
        bathroom: {
          items: defaultBathroomItems,
        },
      },
    },
    {
      code: "chambre-confort",
      name: tRooms("items.chambre-confort.title"),
      image: "/images/rooms/confort/1.jpg",
      price: tRooms("similarRooms.price", { price: "150" }),
      description: tRooms("items.chambre-confort.description"),
      images: [
        "/images/rooms/confort/1.jpg",
        "/images/rooms/confort/2.jpg",
        "/images/rooms/confort/3.jpg",
      ],
      amenities: defaultAmenities,
      roomDetails: {
        room: {
          items: [
            tRooms("section.roomDetails.items.roomSize", { size: "15" }),
            tRooms("section.roomDetails.items.kingSizeBed"),
            tRooms("section.roomDetails.items.courtyardSide"),
            tRooms("section.roomDetails.items.maxGuests", { count: 2 }),
          ],
        },
        bathroom: {
          items: defaultBathroomItems,
        },
      },
    },
    {
      code: "chambre-superieure",
      name: tRooms("items.chambre-superieure.title"),
      image: "/images/rooms/superieure/1.jpg",
      price: tRooms("similarRooms.price", { price: "175" }),
      description: tRooms("items.chambre-superieure.description"),
      images: [
        "/images/rooms/superieure/1.jpg",
        "/images/rooms/superieure/2.jpg",
        "/images/rooms/superieure/3.jpg",
      ],
      amenities: defaultAmenities,
      roomDetails: {
        room: {
          items: [
            tRooms("section.roomDetails.items.roomSize", { size: "20" }),
            tRooms("section.roomDetails.items.kingSizeBed"),
            tRooms("section.roomDetails.items.courtyardSide"),
            tRooms("section.roomDetails.items.maxGuests", { count: 2 }),
          ],
        },
        bathroom: {
          items: defaultBathroomItems,
        },
      },
    },
    {
      code: "chambre-prestige",
      name: tRooms("items.chambre-prestige.title"),
      image: "/images/rooms/prestige/1.jpg",
      price: tRooms("similarRooms.price", { price: "200" }),
      description: tRooms("items.chambre-prestige.description"),
      images: [
        "/images/rooms/prestige/1.jpg",
        "/images/rooms/prestige/2.jpg",
        "/images/rooms/prestige/3.jpg",
      ],
      amenities: defaultAmenities,
      roomDetails: {
        room: {
          items: [
            tRooms("section.roomDetails.items.roomSize", { size: "25" }),
            tRooms("section.roomDetails.items.kingSizeBed"),
            tRooms("section.roomDetails.items.courtyardSide"),
            tRooms("section.roomDetails.items.maxGuests", { count: 2 }),
          ],
        },
        bathroom: {
          items: defaultBathroomItems,
        },
      },
    },
  ];
};
